import React, { useState } from 'react';
import { SHARED_EXCHANGE_SECURITY } from '../../data/setupGuides';

/**
 * Painel de boas práticas de segurança válidas pra TODAS as corretoras.
 * Renderizado uma vez no ExchangesManager — evita repetir o mesmo texto
 * em cada guide individual. As dicas específicas de cada exchange ficam
 * no CredentialsGuide quando o usuário seleciona uma.
 *
 * Colapsado por default — o usuário expande quando quer revisar.
 */
function SharedExchangeSecurity() {
    const [open, setOpen] = useState(false);
    const data = SHARED_EXCHANGE_SECURITY;

    return (
        <div className='mb-3'>
            <button
                type='button'
                className='btn btn-sm btn-outline-warning w-100 text-start'
                onClick={() => setOpen(o => !o)}
            >
                {open ? '▲' : '▼'} 🛡️ {data.title}
            </button>

            {open && (
                <div className='card card-body border-warning mt-2 p-3' style={{ fontSize: 14 }}>
                    {data.intro && <p className='mb-3 text-muted' style={{ fontSize: 13 }}>{data.intro}</p>}

                    <div className='row g-2'>
                        {data.tips.map((tip, i) => (
                            <div key={i} className='col-12 col-md-6'>
                                <div className='border-start border-warning border-3 ps-2 py-1'>
                                    <strong style={{ fontSize: 13 }}>{tip.label}</strong>
                                    <p className='mb-0 mt-1 text-muted' style={{ fontSize: 12 }}>{tip.detail}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <small className='text-muted fst-italic mt-3'>
                        Dicas específicas de cada corretora (passos pra criar sub-account, etc.) aparecem ao
                        selecionar a exchange no form de cadastro.
                    </small>
                </div>
            )}
        </div>
    );
}

export default SharedExchangeSecurity;
